import React, { createContext, useState,  } from 'react';

/**
 * Contexto para fornecer utilitários de dados.
 */
export const DataUtilsContext = createContext();

/**
 * Provedor de contexto para fornecer utilitários de dados.
 * @param {Object} props As propriedades do componente DataUtilsProvider.
 * @param {React.ReactNode} props.children Os componentes filhos para os quais os utilitários de dados são fornecidos.
 */
export function DataUtilsProvider({ children }) {
	/**
   * Estado para armazenar dados relacionados aos estados.
   */
	const [statesData, setStatesData] = useState({
		label: 'Estado',
		placeholder: 'Selecione um Estado',
		message: 'Selecione um Estado',
		items: [],
	});

	return (
		<DataUtilsContext.Provider
			value={{
				statesData,
				setStatesData,
			}}
		>
			{children}
		</DataUtilsContext.Provider>
	);
}
